import { PlusCircle } from '@phosphor-icons/react';
import { BaseButton } from './Button';
import styled from '@emotion/styled';

type AddButtonProps = {
  disabled?: boolean;
  onClick: () => void;
};

/**
 * Add Button component, part of Delogue design system.
 * @param onClick - on click handler
 * @param disabled - if true, the button will be disabled
 */
export const AddButton = ({ disabled = false, onClick }: AddButtonProps) => {
  return (
    <Button disabled={disabled} onClick={onClick}>
      <PlusCircle size={24} weight="fill" />
    </Button>
  );
};

const Button = styled(BaseButton)<{ disabled?: boolean }>`
  color: ${({ disabled, theme }) =>
    disabled ? theme.palette.bg.disabledSubtle : theme.palette.fg.secondary};
`;
